export class VettedStatementTransformer {
  static transform(obj) {
    let vettedStatement = {};
    vettedStatement.id = obj.id;
    vettedStatement.shortText = obj.attributes.short_text;
    vettedStatement.longText = obj.attributes.long_text;
    vettedStatement.archived_at = obj.attributes.archived_at;
    return vettedStatement;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/vettedStatements/vettedStatement.transformer.js